<template>
    <span class="calc-flag-icon">
        <country-flag :country="country" size="normal" />
    </span>
</template>

<script>
import CountryFlag from 'vue-country-flag-next'

export default {
    name: 'CalcFlagIcon',

    components: { CountryFlag },

    props: {
        code: {
            type: String,
            required: true,
        },
    },

    computed: {
        country() {
            return typeof this.code === 'string' ? this.code.toLowerCase() : ''
        },
    },
}
</script>

<style scoped>
.calc-flag-icon {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    overflow: hidden;
    box-sizing: border-box;
    background: #fff;
    vertical-align: middle;
}

.calc-flag-icon :deep(.flag) {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0;
    transform: translate(-50%, -50%) scale(0.52);
    transform-origin: center;
}
</style>
